import { categories } from '@/mocks/categories';

const cardColors = [
  'bg-[#f5e6d8]', 'bg-[#e0ebe4]', 'bg-[#f0efeb]', 'bg-[#f2e8d5]',
  'bg-[#e8e4df]', 'bg-[#f3eee8]', 'bg-[#eaf0e8]', 'bg-[#f0eae0]',
  'bg-[#ede8e0]', 'bg-[#f2ece4]', 'bg-[#efe9df]', 'bg-[#f4efe8]',
  'bg-[#ece6dc]', 'bg-[#f1ece4]',
];

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" id="categories">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase">
            / Product Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-3 leading-[1.15]">
            <span className="block font-bold">Browse By</span>
            <span className="block italic font-normal text-foreground-700">Category</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 smooth-transition cursor-pointer"
            >
              {/* Image area */}
              <div className={`aspect-[4/3] ${cardColors[i % cardColors.length]} relative overflow-hidden`}>
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - ItaobuySpreadsheet category`}
                  title={`${cat.name} - ItaobuySpreadsheet product sourcing`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Label */}
              <div className="px-4 py-3">
                <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">Browse products</p>
              </div>
            </a>
          ))}
        </div>

        {/* View All */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium border-2 border-primary-300 text-primary-700 rounded-full hover:bg-primary-50 smooth-transition whitespace-nowrap cursor-pointer"
          >
            View All Categories
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}